export const fieldNameMaps = {
    needDeparture: "Çıxışa ehtiyac varmı",
    departureNote: "Hadisə yerinə çıxmamağın səbəbi",
    commAccidentDate: "Hadisə vaxtı",
    departureDate: "Çıxış vaxtı",
    commPlace: "Hadisə yeri",
    observationPlace: "Baxış yeri",
    regionId: "Ərazi",
    victim: "Zərər vuran",
    incidentCauseId: "Səbəblər",
    otherCause: "Açıqlama (digər səbəb)",
    observationDate: "Baxış vaxtı",
    leaveDate: "Ayrılma vaxtı",
    vehicleCount: "NV sayı",
    zbt: "ZBT",
    commChainAccident: "Zəncirvari qəza",
    commInjured: "Xəsarət alan",
    protocol: "Daxili protokol",
    departureResult: "Əlavə qeyd",
    finishReason: "Səbəbi (yekunlaşdırma)",
    finishDate: "Tarix (yekunlaşdırma)",
    otherFinishReason: "Açıqlama (yekunlaşdırma)",
    finishNote: "Qeydlər (yekunlaşdırma)",
    insured: "Sığortalı/Üçüncü tərəf",
    damageType: "Zərər növü",
    regNumber: "Dövlət qeydiyyat nişanı",
    insurancePeriod: "Sığorta müddəti",
    policyNumber: "Sığorta şəhadətnaməsi",
    personType: "Şəxs növü",
    identNumber: "FİN/VÖEN",
    otherIdentNumber: "Digər FİN/VÖEN",
    personName: "Ad/Soyad/Adı",
    phone: "Əlaqə nömrəsi",
    drivingYears: "Sürücülük təcrübəsi",
    insuranceCompId: "Sığorta şirkəti",
    noInfoCompany: "Sığorta şirkəti yoxdur",
    vin: "VİN",
    vinCheck: "VİN uyğunluğu",
    partPersonName: "Sürücü/Şəxs adı",
    partPersonPhone: "Sürücü/Şəxs telefonu",
    otherDriverPhone: "Əlavə nömrə",
    otherPropertyName: "Əmlak adı",
    purposeOfUse: "İstifadə məqsədi",
    otherPurposeOfUse: "Digər məqsəd",
    productionYear: "İstehsal ili",
    damageSum: "Təqribi zərər",
    driverLicense: "Sürücülük hüququ",
    mileage: "Yürüş",
    officialAgencyId: "Rəsmi dövlət qurumu",
    otherAgency: "Digər qurum",
    serviceCenterId: "Təmir mərkəzi",
    notSendService: "TM göndərilmədi",
    evacuationStatus: "Evakuasiya olunub",
    subragation: "Subroqasiya ehtimalı",
    fraud: "Dələduzluqda şübhə",
    customBrandModel: "Marka/model",
    createdBy: "Yaradan",
    updatedBy: "Yeniləyən",
    accidentStatus: "Status",
    participantType: "İştirakçı növü",
    insuredName: "Sığortalı",
    regNumber: "Dövlət Qeydiyyat Nişanı",
    policyNumber: "Sığorta Şəhadətnaməsi №",
    accidentDate: "Hadisə Tarixi",
    callDate: "Zəng Tarixi",
    phone: "Telefon",
    place: "Hadisə yeri",
    Descr: "Qeyd",
    driver: "Sürücü",
    driverPhone: "Sürücü nömrəsi",
    brandModel: "Marka model / Nümunə",
    callNotes: "Sürücünün qeydləri",
    UpdatedBy: "Düzəliş edən / Tarix",
    UpdateAccident: "Düzəliş",
    DamageSum: "Zərər məbləği",
    PlaceName: "Hadisə yeri",
    ServiceCenterId: "Xidmət Mərkəzinin ID-si",
    PartPersonName: "Sığortalı",
    BrandId: "Marka ID-si",
    ModelId: "Model",
    OfficialAgencyId: "Rəsmi Agentlik ID-si",
    DriverLicense: "Sürücülük Vəsiqəsi",
    VinCheck: "VIN Yoxlaması",
    PartPersonPhone: "Təmirçi Telefonu",
    ServiceCenterName: "Xidmət Mərkəzinin Adı",
    NotSendService: "Xidmət Göndərilməyib",
    OtherDriverPhone: "Digər Sürücünün Telefonu",
    Subragation: "Subrogasiya",
    RegionName : "Ərazi",
    ChainAccident : "Zəncirvari qəza",
    Injured : "Bədən xəsarəti",
     IsAnimal : "Heyvana xəsarət",
     IsProperty : "Əmlak",
      RegionId : "Ərazi"
};